import cx from 'classnames'

import { Nullish } from '@web/types'

import styles from './NewProgressCircle.module.scss'

const GRADIENT_ID = 'circle_gradient'

interface Props {
  total?: Nullish<number>
  count: number
  color?: string
  radius?: number
  className?: string
  track?: boolean
  gradient?: boolean
}
export default function NewProgressCircle({
  total,
  count,
  color,
  radius = 29.5,
  className,
  track = false,
  gradient = false,
}: Props) {
  // 원 전체 둘레 (π * 2 * Radius)
  const circumference = 3.14 * 2 * radius

  // 채워진 정도 %
  // total이 없는경우에 gradient는 true
  const percentage = total ? Math.min(100, (count / total) * 100) : 0

  // 원 시작점 계산 (원 전체 둘레 - 채워야 할 길이)
  const dashoffset = circumference - circumference * 0.01 * percentage

  return (
    <svg viewBox="0 0 68 68" className={cx(className, styles.circle)} aria-hidden="false">
      <defs>
        <linearGradient id={GRADIENT_ID} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="6.94%" stopColor="#00CF5B" />
          <stop offset="91.2%" stopColor="#298BFF" />
        </linearGradient>
      </defs>
      <circle className={styles.background} fill="none" cx="34" cy="34" r={radius} strokeWidth={9} />
      {count > 0 &&
        (gradient ? (
          <circle fill="none" r={radius} stroke={`url(#${GRADIENT_ID})`} strokeWidth={8} cx="34" cy="34" />
        ) : (
          <>
            {track && (
              <circle
                className={styles.track}
                fill="none"
                r={radius}
                strokeWidth={9}
                strokeDasharray={circumference}
                strokeDashoffset={dashoffset}
                strokeLinecap="round"
                cx="34"
                cy="34"
              />
            )}
            <circle
              className={styles.progress}
              fill="none"
              r={radius}
              stroke={color}
              strokeWidth={track ? 6 : 8}
              strokeDasharray={circumference}
              strokeDashoffset={dashoffset}
              strokeLinecap="round"
              cx="34"
              cy="34"
            />
          </>
        ))}
    </svg>
  )
}
